import { Button, Input } from 'reactstrap'
import TimeUtil from 'utils/time-util'
import CustomerOrderShipmentStatusBadge from 'domains/customer-order/atoms/shipment-status-badge'
import CustomerShipmentPickupStatusBadge from 'domains/customer-shipment/atoms/pickup-status-badge'
import CustomerOrderStatusBadge from 'domains/customer-order/atoms/status-badge'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'

const propTypes = {
  shipment          : PropTypes.object,
  selectedShipments : PropTypes.array,
  handleSelectRow   : PropTypes.func,
  handleRemoveRow   : PropTypes.func,
  showCheckbox      : PropTypes.bool
}

const defaultProps = {
  handleSelectRow : () => {},
  handleRemoveRow : () => {},
  showCheckbox    : true
}

/**
 * Row to show some attribute of ::Customer::Shipment for Request Pickup Table
 * @param {Object} order - Customer::Shipment
 * @param {Array<Object>} selectedShipments - array of selected/checked Customer::Shipment in request pickup page
 * @param {Function} handleSelectRow - Function that triggered when Customer::Shipment checked
 * @param {Function} handleRemoveRow - Function that triggered when Customer::Shipment unchecked
 * @param {Boolean} showCheckbox - show checkbox
 */

const CustomerShipmentRequestPickupTableRow = ({
  shipment,
  selectedShipments,
  handleSelectRow,
  handleRemoveRow,
  showCheckbox
}) => {
  const checked = selectedShipments ? selectedShipments.some((item) => (item.id === shipment.id)) : false

  const toggleCheckbox = () => {
    checked ? handleRemoveRow(shipment) : handleSelectRow(shipment)
  }
  return (
    <tr>
      {
        showCheckbox && (
          <td>
            <Input
              id={ `shipment-checkbox-${shipment.id}` }
              type='checkbox'
              checked={ checked }
              onChange={ toggleCheckbox }
              style={{ cursor: 'pointer' }}
              className='m-0'
            />
          </td>
        )
      }
      <td>
        <CustomerOrderShipmentStatusBadge status={ shipment.status } />
      </td>
      <td>
        <CustomerShipmentPickupStatusBadge status={ shipment.pickup_status } />
      </td>
      <td>
        { shipment.order.number } <br/>
        <Button
          color='primary'
          tag={ Link }
          size='sm'
          to={ `/app/customer-orders/${shipment.order.id}` }
        >
          { 'Lihat Order' }
        </Button>

      </td>
      <td>
        <CustomerOrderStatusBadge status={ shipment.order.status } />
      </td>
      <td style={{ whiteSpace: 'pre-wrap' }}>
        {
          [
            shipment.recipient_name,
            shipment.recipient_phone || '-'
          ].join('\n')
        }
      </td>
      <td>
        { TimeUtil.format(shipment.pickup_start_date) }
        <br />
        { TimeUtil.format(shipment.pickup_start_date, 'HH:mm:ss') }
      </td>
      <td style={{ whiteSpace: 'pre-wrap' }}>
        {
          [
            shipment.courier,
            shipment.courier_service_type,
            shipment.destination_kota
          ].join('\n')
        }
      </td>
      <td>{ shipment.tracking_no }</td>
    </tr>
  )
}

CustomerShipmentRequestPickupTableRow.propTypes    = propTypes
CustomerShipmentRequestPickupTableRow.defaultProps = defaultProps

export default CustomerShipmentRequestPickupTableRow
